import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const TechnicalNavItem = _ref => {
  let {
    report,
    claimGroup,
    user,
    tab,
    id
  } = _ref;
  const {
    t
  } = useTranslation();
  const tabName = () => {
    switch (tab.name) {
      case 'DeSection::AdditionalInformation':
        if (tab.type === 'basic') {
          return t(`${'further_requests'}_${tab.iteration_count}`);
        } else {
          return 'Objection';
        }
      case 'DeSection::BsfzCertificate':
        if (tab.sequence === 'initial') {
          return t('bsfz_certificate');
        } else {
          return t('bsfz_certificate') + ' 2';
        }
      default:
        return '';
    }
  };
  const linkName = () => {
    switch (tab.name) {
      case 'DeSection::AdditionalInformation':
        return 'additional_informations';
      case 'DeSection::BsfzCertificate':
        return 'bsfz_certificates';
      default:
        return '';
    }
  };
  return /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    as: Link,
    active: +id === tab.id,
    to: `/${user.account_type}/claim_groups/${claimGroup.id}/technical_proof/project_reports/${report.id}/${linkName()}/${tab.id}`
  }, tabName()));
};
export default TechnicalNavItem;